import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        investProjectName: null, // 投资项目名称
        projectName: null, // 招标项目名称
        registrationId: null, // 招标登记编号
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "投资项目名称：",
          value: "investProjectName",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "招标项目名称：",
          value: "projectName",
          placeholder: "请输入"
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "招标项目名称",
          prop: "projectName",
          isShow: true,
          width: 300,
        },
        {
          label: "状态",
          slotName: "state",
          width: 80,
        },
        {
          label: "投资项目名称",
          prop: "investProjectName",
          width: 180,
        },
        {
          label: "投资项目代码",
          prop: "investProjectCode",
          width: 180,
        },
        {
          label: "招标项目类型",
          prop: "tenderProjectTypeName",
          width: 130,
        },
        {
          label: "招标方式",
          prop: "tenderTypeName",
          width: 120,
        },
        {
          label: "招标人",
          prop: "tenderCorpName",
          width: 180,
        },
        {
          label: "发布人名称",
          prop: "issueName",
          width: 180,
        },
        {
          label: "预估发包价（元）",
          prop: "contractPrice",
          width: 150,
        },
        {
          label: "招标公告预计发布时间",
          prop: "noticeReleaseTime",
          width: 200,
        },
        {
          label: "招标计划发布时间",
          prop: "releaseTime",
          width: 200,
        },
        {
          label: "招标监管部门",
          prop: "regulatorsName",
          width: 280,
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
    }
  },

  // 接收父组件传递的数据
  props: {

  },

  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList(e) {
      // 参数不为空
      if (e) {
        // 招标登记编号
        this.form.registrationId = e;
      }
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/biddingPlan/getBiddingPlanChooseList", {
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 点击招标项目名称的方法
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面
        this.$parent.fun_BiddingPlan(e.val.id);
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
}